import { createFeatureSelector, createSelector } from '@ngrx/store';
import { Response } from './assignment.model';

export const selectInstructorAssignmentsState = createFeatureSelector<Response>('instructorAssignments');

export const selectInstructorAssignments = createSelector(selectInstructorAssignmentsState, (entities) => entities);
